import React from "react";
import Table from "../../../../core/Table";
import BasicDialog from "../../../../core/BasicDialog";
import { labels } from "../../../../../localization/labels";
import ProcessComponent from "../../../../core/ProcessComponent";
import { constants } from "../../../../../utils/Constants";

const Extensions = ({
  node,
  data,
  columns,
  paginationOptions,
  onTableChange,
  onRowClick,
  entity,
  show,
  handleClose,
  disabled,
  onChange,
  onSave,
  maxLength,
  pageInfo,
  sortInfo,
  handleEntered
}) => {
  return (
    <ProcessComponent processes={[constants.OPERATION_ENTITY_ADMINISTRATION]}>
      <div className="container">
        <div className="tabVerticalSize" />
        <div className="distance-from-tab" />
        <Table
          node={node}
          data={data}
          columns={columns}
          onTableChange={onTableChange}
          paginationOptions={paginationOptions}
          onRowClick={onRowClick}
          tableLabel={labels.extensions}
          pageInfo={pageInfo}
          sortInfo={sortInfo}
          showTableHeader
        />
        <BasicDialog
          dialogTitle={labels.extensions}
          entity={entity}
          show={show}
          handleClose={handleClose}
          disabled={disabled}
          onChange={onChange}
          onSave={onSave}
          maxLength={maxLength}
          handleEntered={handleEntered}
        />
      </div>
    </ProcessComponent>
  );
};

export default Extensions;
